import { CFormInput } from '@coreui/react'
import { IMaskMixin } from 'react-imask'

export const CFormInputWithMask = IMaskMixin(({ inputRef, ...props }:any) => (
    <CFormInput
      {...props}
      ref={inputRef}
    />
  ))